<template>
    <div class="cart-unavailable-title-wrapper" v-if="type == 2">
        <h3 class="category-title" style="margin-bottom: 30px;">{{ trans('Unavailable items') }}</h3>
        <p>{{ trans('Some of the selected items are no longer available. You can add them to your favorites to purchase them if they become available again') }}</p>
    </div>
    <div class="cart-sec__element_wrapper" v-for="(card,index) in cards">
        <div class="cart-sec__element cart-element" >
            <a :href="card.img" target="_blank" class="cart-element__img">
                <picture>
                    <source :srcset="card.img" type="image/webp">
                    <img class="img-element" :src="card.img" alt="">
                </picture>
            </a>
            <div class="cart-element__info">
                <h3 class="cart-element__title">
                    <a class="cart-element__link" :href="card.menu_data.slug+card.card_id">{{ card.name }}</a>
                </h3>
                <div v-if="type == 1" class="cart-element__size">{{ trans('Size') }}:
                    <b>{{ card.size }}</b>
                </div>
                <div v-else class="cart-element_unavailable">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11" cy="11" r="10.3125" stroke="black" stroke-width="1.37501"/>
                        <path d="M14.8871 7.11572L7.10891 14.8939" stroke="black" stroke-width="1.37501" stroke-linecap="round"/>
                        <path d="M7.10889 7.1062L14.8871 14.8844" stroke="black" stroke-width="1.37501" stroke-linecap="round"/>
                    </svg>
                    <span>{{ trans('Out of stock') }}</span>
                </div>
                <div v-if="type == 1">
                    <template v-if="card.price_old_str">
                        <span class="cart-element__price product__sale-price" style="margin-right: 8px">{{ card.price_str }} {{ this.$parent.basket.currency_sign }}</span>
                        <span class="cart-element__price  product__old-price ">{{ card.price_old_str }} {{ this.$parent.basket.currency_sign }}</span>
                    </template>
                    <span class="cart-element__price  product__text-def "  v-if="!card.price_old_str">{{ card.price_str }} {{ this.$parent.basket.currency_sign }}</span>
                </div>
                <div v-else class="cart-element_wish" @click.prevent="addToWish(card,index)">
                    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.6837 18.7323L20.2695 10.1775C21.3828 9.05497 22.0044 7.54547 22 5.97471C21.9956 4.40394 21.3657 2.89784 20.2461 1.78139C19.6965 1.22816 19.041 0.788294 18.3176 0.487391C17.5943 0.186489 16.8175 0.0305553 16.0325 0.0286611C15.2475 0.0267668 14.4699 0.17895 13.7451 0.476358C13.0202 0.773765 12.3625 1.21046 11.8102 1.76104L10.9907 2.57934L10.1588 1.75154L10.0213 1.61719C8.90073 0.560037 7.40431 -0.0205129 5.85428 0.000553948C4.30425 0.0216208 2.82459 0.642619 1.73395 1.72982C-0.587119 4.0436 -0.576119 7.80399 1.75595 10.1286L10.3871 18.7323C10.7446 19.0892 11.3262 19.0892 11.6837 18.7323ZM12.7879 2.71504C13.2124 2.29216 13.7179 1.95687 14.275 1.72871C14.8321 1.50056 15.4296 1.3841 16.0328 1.38612C16.6359 1.38814 17.2326 1.5086 17.7881 1.74049C18.3437 1.97237 18.8469 2.31103 19.2684 2.73676C20.133 3.59929 20.6197 4.76242 20.6238 5.97567C20.628 7.18892 20.1491 8.35523 19.2904 9.22346V9.22618L11.0347 17.4499L2.73222 9.17325C0.926798 7.3738 0.925423 4.46428 2.7116 2.68383C3.13536 2.26139 3.6401 1.92645 4.19638 1.69852C4.75266 1.47059 5.34936 1.35425 5.95167 1.35627C6.55399 1.35829 7.14987 1.47864 7.70457 1.71029C8.25927 1.94195 8.76169 2.28027 9.18253 2.70554L10.5026 4.02188C10.5665 4.08569 10.6426 4.13634 10.7265 4.17091C10.8104 4.20548 10.9005 4.22327 10.9914 4.22327C11.0823 4.22327 11.1723 4.20548 11.2562 4.17091C11.3402 4.13634 11.4163 4.08569 11.4802 4.02188L12.7879 2.71504Z" fill="#FF0000"/>
                    </svg>
                    <span>{{ trans('Add to favorites') }}</span>
                </div>
            </div>
            <div class="cart-element__del">
                <svg @click="deleteBasket(card,index)" class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.7734 5.25L5.27344 18.75" stroke="#9B9FA1" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M18.7734 18.75L5.27344 5.25" stroke="#9B9FA1" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cards: {
            type: Object,
            required: true,
        },
        not_cards: {
            type: String,
        },
        type: {
            type: Number,
            default: 1
        },
    },
    name: "card-horizontal",
    methods: {
        deleteBasket(card,index){
           this.$parent.$parent.$refs.header.deleteBasket(card,index)
        },
        addToWish(card,index){
            if (this.$parent.$parent.$refs.header.cardExistInWish(card) == false) {
                this.$parent.$parent.$refs.header.cardAddToWish(card)
            }
            this.$parent.$parent.$refs.header.deleteBasket(card,index)
        }
    },
}
</script>
